<template>
  <v-expansion-panels flat accordion>
    <v-expansion-panel>
      <v-expansion-panel-header class="white--text" color="purple accent-4">New Volunteer Activity</v-expansion-panel-header>
      <v-expansion-panel-content>
        <form method="POST">
          <v-row>
            <v-col cols="4">
              <label for>Date</label>
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="data.date"
                    outlined
                    dense
                    readonly
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="data.date" no-title @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <label>Volunteer</label>
              <v-select
                v-model="data.volunteer_id"
                :items="volunteers"
                item-value="id"
                dense
                outlined
              >
                <template slot="selection" slot-scope="data">
                  <!-- HTML that describe how select should render selected items -->
                  {{ data.item.code }} ({{ data.item.name }})
                </template>
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item.code }} ({{ data.item.name }})
                </template>
              </v-select>
            </v-col>
            <v-col cols="4">
              <label>DOTS App Status</label>

              <v-select
                v-model="data.dots_app_status"
                :items="[{value:1,text:`No`},{value:2,text:`Yes`}]"
                item-text="text"
                item-value="value"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="12" style="text-align:center;">
              <v-btn class="form-btn" @click="$emit(`submitForm`,data)">
                <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    startDateMenu: null
  }),
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          date: "",
          dots_app_status: "",
          volunteer_id: ""
        };
      }
    }
  },
  created() {
    this.$store.dispatch("Volunteer/getVolunteers");
  },
  computed: {
    ...mapState("Volunteer", ["volunteers"])
  }
};
</script>

<style>
</style>